import { render, staticRenderFns } from "./TuiJian.vue?vue&type=template&id=3d856b9a&scoped=true&"
import script from "./TuiJian.vue?vue&type=script&lang=js&"
export * from "./TuiJian.vue?vue&type=script&lang=js&"
import style0 from "./TuiJian.vue?vue&type=style&index=0&id=3d856b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d856b9a",
  null
  
)

export default component.exports